/**
 * Created by administrator on 2017/3/29.
 */
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import $http from '$http';
import {
    MAP_LIST
} from '$http';

export default {
    data() {
        return {
            dialogFormVisible: false,
            projectTypeList: [],
            opts: {},
            form: this.getInitForm()
        }
    },
    methods: {
        getInitForm() {
            return cloneDeep({
                agentName: "",
                c_name: "",
                projectType: 0,
                orderStartTime: "",
                orderEndTime: ""
            });
        },
        settings() {
            return cloneDeep({
                type: 1 //1:订单数据导出； 2：出库单导出
            });
        },
        show(options) {
            let opts = Object.assign({}, this.settings(), options);
            this.opts = opts;
            this.dialogFormVisible = true;
            let mlist = cloneDeep(MAP_LIST.INTENT_PROJECT);
            mlist.splice(0, 0, {
                id: 0,
                name: "全部"
            });
            this.projectTypeList = mlist;
        },
        onSubmit() {
            if (util.compareDate(util.time2str(this.form.orderStartTime), util.time2str(this.form.orderEndTime))) {
                this.$notify.error({
                    title: '错误',
                    message: '结束时间不能小于开始时间'
                });
                return;
            }

            let params = Object.assign({}, {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession
            }, this.form);

            if (this.form.orderStartTime == "") {
                params.orderStartTime = "";
            } else {
                params.orderStartTime = util.time2str(this.form.orderStartTime);
            }

            if (this.form.orderEndTime == "") {
                params.orderEndTime = "";
            } else {
                params.orderEndTime = util.time2str(this.form.orderEndTime);
            }

            //GET:出库单导出 /api/DataExport/StockOutExport
            //GET:订单数据导出 /api/DataExport/OrderDataExport
            let url = '';
            if (this.opts.type == 1) {
                url = 'api/DataExport/OrderDataExport'; //订单数导出
            } else if (this.opts.type == 2) {
                url = 'api/DataExport/StockOutExport'; //出库单导出
            } else {
                url = 'api/DataExport/OrderDataExport'; //订单数导出
            }

            util.exportToFileV2(url, params, this);
        },
        closeCallback() {
            this.form = this.getInitForm();
        },
        resetData() {
            this.form = this.getInitForm();
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/exportFunction/component/exportFnDialog/vm.js